<template>
    <activity
        :obj="form"
        :activeTab="activeTab"
        :messages="this.messages"
        @openclient="openclient"
        @inRelease="inRelease"
        @showReopen="showReopen"
        @showClose="showClose"
        @updateCard="this.$emit('updateCard')"
    />
</template>

<script>
import activity from './activity/index'
import { storeS } from '@/store';

export default{
    props: ['obj', 'activeTab', 'messages'],
    // Оголошуємо події явно, щоб лістенери батька (@inRelease тощо) не прокидались
    // через fallthrough на кореневий <activity> і не спрацьовували двічі
    emits: ['inRelease', 'showReopen', 'showClose', 'openclient', 'updateCard'],
    components: {
        activity
    },
    data(){
        return{
            msg: "",
            form: {
                message: ""
            }
        }
    },
    created(){
        this.getdata();
    },
    methods:{
        inRelease(e) {
            this.$emit('inRelease', e)
        },
        showReopen(e) {
            this.$emit('showReopen', e)
        },
        showClose(e) {
            this.$emit('showClose', e)
        },
        getdata(){
            this.form = this.obj
        },
        openclient(e){
            this.$emit('openclient', e)
        }
    },
    computed: {
        user() {
            return storeS.userbase
        },
        workers(){
            return storeS.workers
        }
    }
}
</script>